import { WebGLData } from '../../../Content';
import { isMobile } from 'react-device-detect';
import { useCallback } from 'react';
import { useMediaQuery } from '@material-ui/core';

interface WebGLContentProps {
  content: WebGLData;
}

export const WebGLContent: React.FC<WebGLContentProps> = ({ content }) => {
  const isLandscape = useMediaQuery('(orientation: landscape)');
  const isPortrait = useMediaQuery('(orientation: portrait)');

  const getIsValidOrientation = useCallback(() => {
    if (!isMobile) return true;

    const orientation = content.requireMobileOrientation;
    switch (orientation) {
      case undefined:
        return true;
      case 'landscape':
        return isLandscape;
      case 'portrait':
        return isPortrait;
    }
  }, [content.requireMobileOrientation, isLandscape, isPortrait]);

  return (
    <div
      style={{
        width: '100%',
        height: '100%',
      }}
    >
      {getIsValidOrientation() ? (
        <iframe
          title="webgl-viewer"
          src={content.src}
          style={{
            width: '100%',
            height: '100%',
          }}
          frameBorder="0"
          allow="autoplay; fullscreen; picture-in-picture"
          allowFullScreen
        ></iframe>
      ) : (
        <div
          style={{ width: '100%', height: '100%', backgroundColor: '#212121' }}
        >
          <div
            style={{
              width: '80%',
              height: '90%',
              margin: 'auto',
              backgroundImage: 'url("assets/rotate_landscape.jpg")',
              backgroundSize: 'contain',
              backgroundRepeat: 'no-repeat',
              backgroundPosition: 'center',
            }}
          />
        </div>
      )}
    </div>
  );
};
